"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyLicenseeCreationSchema = exports.IndividualLicenseeCreationSchema = void 0;
const licensee_enums_1 = require("../enums/licensee-enums");
const zod_1 = require("zod");
/*
 * Validation for creating a Licensee that is of type Individual
 */
exports.IndividualLicenseeCreationSchema = zod_1.z.object({
    type: zod_1.z.literal(licensee_enums_1.LicenseeType.INDIVIDUAL),
    contactEmail: zod_1.z.string().email({ message: 'Valid email is required' }),
    contactPhone: zod_1.z.string().nullish(),
    // Individual-specific required fields
    firstName: zod_1.z.string().min(1, 'First name is required'),
    lastName: zod_1.z.string().min(1, 'Last name is required'),
    idNumber: zod_1.z.string().min(5, 'ID number is required'),
});
/*
 * Validation for creating a Licensee that is of type Company
 */
exports.CompanyLicenseeCreationSchema = zod_1.z.object({
    type: zod_1.z.literal(licensee_enums_1.LicenseeType.COMPANY),
    contactEmail: zod_1.z.string().email({ message: 'Valid email is required' }),
    contactPhone: zod_1.z.string().nullish(),
    // Company-specific required fields
    legalName: zod_1.z.string().min(1, 'Legal name is required'),
    registrationNumber: zod_1.z.string().min(1, 'Registration number is required'),
    taxNumber: zod_1.z.string().nullish(),
    representativeName: zod_1.z.string().nullish(),
    representativeEmail: zod_1.z.string().email().nullish(),
});
